var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { attrs: { id: "inPlayerPlaya" } }, [
      _vm._v("进入按钮事件：" + _vm._s(_vm.inPlayerPlaya))
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "not_vjscontrolbar" } }, [
      _vm._v("not_vjscontrolbar:" + _vm._s(_vm.not_vjscontrolbar))
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "initVideoPlayerBor" } }, [
      _vm._v("initVideoPlayerBor:" + _vm._s(_vm.initVideoPlayerBor))
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "startLearning" } }, [
      _vm._v("startLearning：" + _vm._s(_vm.startLearning))
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "beforeLearingSupervised" } }, [
      _vm._v("beforeLearingSupervised：" + _vm._s(_vm.beforeLearingSupervised))
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "beforeONPLAY" } }, [
      _vm._v("beforeONPLAY：" + _vm._s(_vm.beforeONPLAY))
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "beforeplay" } }, [
      _vm._v("beforeplay：" + _vm._s(_vm.beforeplay))
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "beforesupervisedFace" } }, [
      _vm._v("beforesupervisedFace：" + _vm._s(_vm.beforesupervisedFace))
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "beforeCompressFileLength" } }, [
      _vm._v("照片上传压缩前的大小：" + _vm._s(_vm.beforeCompressFileLength))
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "afterCompressFileLength" } }, [
      _vm._v("照片上传压缩后的大小：" + _vm._s(_vm.afterCompressFileLength))
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "CompressFileErr" } }, [
      _vm._v("照片压缩时报错信息：" + _vm._s(_vm.CompressFileErr))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30458020", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30458020","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/webdebug.vue
// module id = null
// module chunks = 